// src/hooks/useLobbyLogic.js
import { useState, useCallback } from 'react';

export function useLobbyLogic(userProgress) {
  const [isJumping, setIsJumping] = useState(false);
  
  const unlocked = userProgress.unlockedContent || [];

  const triggerJump = useCallback(() => {
    setIsJumping(true);
    setTimeout(() => setIsJumping(false), 600);
  }, []);

  const checkAccess = useCallback((section) => {
    
    // 2. Secciones que SIEMPRE están abiertas por diseño
    const alwaysOpen = ['modules_base', 'grammar_base', 'vocabulary_hub'];
    if (alwaysOpen.includes(section.id)) return true;

    // 3. Secciones que dependen de compra previa (Zona Misteriosa)
    return unlocked.includes(section.id);
  }, [ unlocked]);

  return {
    isJumping,
    triggerJump,
    checkAccess
  };
}